module.exports = __webpack_public_path__ + "img/cape-town-city-logo-icon.1164af6d.png";